export function deduplicateArray<T>(array: T[]): T[] {
  const set = new Set(array);
  const deduplicatedArray = Array.from(set);

  return deduplicatedArray;
}
